import React, { useRef } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentForm from 'modules/Business/modules/PaymentForm';
import { stripeApiKey } from 'utils/config';

const stripePromise = loadStripe(stripeApiKey);

export default function PaymentMethodDialog({
  open,
  businessId,
  onClose,
  onCancel,
  onSuccess,
}) {
  const paymentSavedRef = useRef(false);

  const handleSuccess = () => {
    paymentSavedRef.current = true;
    onSuccess();
  };

  const handleFormClose = () => {
    if (paymentSavedRef.current) {
      paymentSavedRef.current = false;
      onClose();
      return;
    }
    onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 1600 }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography component="div" sx={{ fontSize: 20, fontWeight: 750, color: '#111' }}>
          Add a payment method
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5, color: 'rgba(0,0,0,0.60)' }}>
          Enter your card details securely with Stripe. Kaiylee never receives or stores them.
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: 2.5 }}>
        <Elements stripe={stripePromise}>
          <PaymentForm
            businessId={businessId}
            onClose={handleFormClose}
            onSuccess={handleSuccess}
          />
        </Elements>
      </DialogContent>
    </Dialog>
  );
}
